<deprecated-labeled-field
  class="labeled"
  *ngIf="label != null; else chip"
  [label]="label"
  [help]="help"
  [required]="required"
>
  <ng-container *ngTemplateOutlet="chip"></ng-container>
</deprecated-labeled-field>
<ng-template #chip>
  <div class="grand-parent">
    <div
      class="container"
      [class.bordered]="bordered"
      [class.disabled]="disabled"
    >
      <chip
        *ngFor="let chip of chips; let i = index; let isLast = last"
        [text]="chip.text"
        [subtext]="chip.subtext"
        [description]="chip.description"
        (remove)="remove(i)"
        [class.selected]="isLast && state == 'removing'"
        [invalid]="chip.invalid"
        [disabled]="chip.disabled"
        [focused]="chip.focused"
      ></chip>
      <div class="input">
        <input
          type="text"
          name="input"
          rv-autocomplete
          autocomplete="off"
          [search]="search"
          [preferredPosition]="autocompletePreferredPosition"
          [class.up]="up"
          (selected)="add([$event])"
          (badSelection)="addBad($event)"
          #input
          [(ngModel)]="searchTerm"
          (keydown)="keyDown($event)"
          (blur)="blur()"
          [placeholder]="placeholder"
          [disabled]="disabled"
        />
      </div>
    </div>
  </div>
</ng-template>
